export default __webpack_public_path__ + "static/media/Limited_Edition_Footer.b5836865.png";